import dayjs from 'dayjs'
require('dayjs/locale/de')
const localeData = require('dayjs/plugin/localeData')
const isBetween = require('dayjs/plugin/isBetween')
dayjs.extend(localeData)
dayjs.extend(isBetween)

export const bioGetTodaysOpening = openingTimes => {
  if (!openingTimes) return null
  const timeNow = dayjs().locale('de')
  const weekdayString = timeNow.format('dddd')
  const openingTimesToday = openingTimes.find(
    opening => opening.weekday === weekdayString
  )

  const weekdays = {
    Montag: 1,
    Dienstag: 2,
    Mittwoch: 3,
    Donnerstag: 4,
    Freitag: 5,
    Samstag: 6,
    Sonntag: 7
  }

  function compareWeekDays(day1, day2) {
    return weekdays[day1] > weekdays[day2]
  }

  const nextOpeningDay =
    openingTimes.find(opening =>
      compareWeekDays(opening.weekday, weekdayString)
    ) || openingTimes[0] // if there is no other opening day that week, take the first one for next week

  let opensTodayAt
  let closesTodayAt
  let opensTodayAtSecond
  let closesTodayAtSecond

  if (openingTimesToday?.open_from && openingTimesToday?.open_until) {
    opensTodayAt = timeNow
      .hour(openingTimesToday?.open_from.split(':')[0])
      .minute(openingTimesToday?.open_from.split(':')[1])
      .startOf('minute')
    closesTodayAt = timeNow
      .hour(openingTimesToday?.open_until.split(':')[0])
      .minute(openingTimesToday?.open_until.split(':')[1])
      .startOf('minute')
  }

  if (
    openingTimesToday?.open_from_second &&
    openingTimesToday?.open_until_second
  ) {
    opensTodayAtSecond = timeNow
      .hour(openingTimesToday?.open_from_second.split(':')[0])
      .minute(openingTimesToday?.open_from_second.split(':')[1])
      .startOf('minute')
    closesTodayAtSecond = timeNow
      .hour(openingTimesToday?.open_until_second.split(':')[0])
      .minute(openingTimesToday?.open_until_second.split(':')[1])
      .startOf('minute')
  }

  const isStillToOpenToday =
    (opensTodayAt && timeNow.isBefore(opensTodayAt)) ||
    (opensTodayAtSecond && timeNow.isBefore(opensTodayAtSecond)) ||
    false

  return {
    isStillToOpenToday,
    isMarketOpen:
      (opensTodayAt &&
        closesTodayAt &&
        timeNow.isBetween(opensTodayAt, closesTodayAt)) ||
      (opensTodayAtSecond &&
        closesTodayAtSecond &&
        timeNow.isBetween(opensTodayAtSecond, closesTodayAtSecond)) ||
      false,
    openingTimesToday,
    nextOpeningDay,
    weekdayString
  }
}
